<template>
  <div>
    <Titel title="Kontakt" />
    <p style="text-align: left; font-style: italic;">Sie haben eine Frage?</p>
    <p style="text-align: right; font-style: italic;">Sie möchten uns Feedback geben?</p>
    <p style="text-align: left; font-style: italic;">Sie wollen uns Ihre Meinung zu unserer Idee mitteilen?</p>
    <p style="text-align: right; font-style: italic;">... oder Sie haben ein anderes Anliegen?</p>
    <br>
    <p style="text-align: center; font-weight: bold;">Schreiben Sie uns eine E-Mail! Wir sind erreichbar unter <a href="mailto:lausitz-mit-zukunft@gmx.de">lausitz-mit-zukunft@gmx.de</a>.</p>
  </div>
</template>

<script>
import Titel from '@/components/Titel'

export default {
  name: 'Kontakt',

  components: {
    Titel
  },

  data () {
    return {

    }
  }
}
</script>

<style scoped>

  p {
    font-size: 1.3em;
  }

</style>



// WEBPACK FOOTER //
// src/views/Kontakt.vue